var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "#BABABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 29.92V32.92C35.0012 33.1985 34.9441 33.4741 34.8326 33.7293C34.721 33.9845 34.5574 34.2136 34.3521 34.4018C34.1469 34.5901 33.9046 34.7335 33.6408 34.8227C33.377 34.9119 33.0974 34.945 32.8201 34.92C29.7429 34.5856 26.7871 33.5341 24.1901 31.85C21.7739 30.3146 19.7254 28.2661 18.1901 25.85C16.5 23.2412 15.4483 20.271 15.1201 17.18C15.0951 16.9034 15.1279 16.6247 15.2166 16.3616C15.3052 16.0985 15.4476 15.8567 15.6348 15.6516C15.822 15.4465 16.0499 15.2827 16.3038 15.1705C16.5578 15.0583 16.8324 15.0002 17.1101 15H20.1101C20.5954 14.9952 21.0658 15.1671 21.4338 15.4835C21.8018 15.8 22.0421 16.2394 22.1101 16.72C22.2367 17.68 22.4715 18.6227 22.8101 19.53C22.9446 19.8879 22.9737 20.2769 22.894 20.6509C22.8142 21.0248 22.6289 21.3681 22.3601 21.64L21.0901 22.91C22.5136 25.4135 24.5865 27.4864 27.0901 28.91L28.3601 27.64C28.6319 27.3711 28.9752 27.1858 29.3492 27.1061C29.7231 27.0263 30.1121 27.0554 30.4701 27.19C31.3773 27.5285 32.32 27.7634 33.2801 27.89C33.7658 27.9585 34.2095 28.2032 34.5266 28.5775C34.8437 28.9518 35.0122 29.4296 35.0001 29.92Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.2f0ae1b35a157fe7daa12aaf59ddb133.svg";
export { ForwardRef as ReactComponent };